const PATHS = {
    SETTINGS: '/settings',
    BRANDS: '/sms/brands',
    CREATE_BRAND: '/sms/brands/new',
    BRAND_VIEW: '/sms/brands/:id',
    BRAND_PREVIEW: '/sms/brands/:id/preview',
    CAMPAIGN_VIEW: '/sms/brands/:brandId/campaigns/:id',
    CREATE_CAMPAIGN: '/sms/brands/:brandId/campaigns/new',
    EDIT_CAMPAIGN: '/sms/campaigns/:id/edit',
    CAMPAIGN: '/sms/campaigns/:id',
    MANAGE_CAMPAIGN_NUMBERS: '/sms/brands/:brandId/campaigns/:id/numbers',
    SMS_REGISTRATION: '/sms-registration',
};

export default PATHS;
